import { css } from 'lit';

const styles = [
  css`
    :host {
      display: none;
      visibility: hidden;
    }
  `,
];

export default styles;
